import Form, { FormComponentProps } from 'antd/lib/form';
import { RouteComponentProps, withRouter } from 'react-router';
import * as React from 'react';
import { Col, Row, Button } from 'antd';
import TrackedBolTable from './TrackedBolTable';
import TrackedBolSearchBar from './TrackedBolSearchBar';
import TableFilterContextProvider from 'components/Forms/DataGrid/TableFilterContextProvider';

export interface Props extends FormComponentProps, RouteComponentProps {
  children?: React.ReactNode;
}

export interface State {
  data: any;
}

class BaseTrackedBolOverview extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  goToRegisterBL = e => {
    e.preventDefault();
    this.props.history.push('/click-n-go/register');
  };

  render() {
    return (
      <TableFilterContextProvider>
        <Row>
          <Col>
            <Row style={{ margin: 5 }}>
              <Button type="primary" icon="plus" onClick={this.goToRegisterBL}>
                Submit New Bill of Lading
              </Button>
            </Row>
            <Row>
              <Col>
                <TrackedBolSearchBar />
              </Col>
            </Row>
            <Row
              style={{
                margin: 5,
                padding: '15px 20px',
                border: 'solid lightgrey 2px',
                borderRadius: '15px',
              }}>
              <TrackedBolTable />
            </Row>
          </Col>
        </Row>
      </TableFilterContextProvider>
    );
  }
}

const TrackedBolOverviewForm = Form.create<Props>({
  name: 'TrackedBolOverview',
})(BaseTrackedBolOverview);

const TrackedBolOverview = withRouter(TrackedBolOverviewForm);
export default TrackedBolOverview;
